import React from "react";
import { rescheduleColumns } from "../model/constants";

const ROWS = 6;
const TITLE_WIDTHS = ["w-3/4", "w-2/3", "w-5/6", "w-1/2", "w-3/5", "w-2/3"] as const;

const Bar: React.FC<{ className: string }> = ({ className }) => (
  <div className={`animate-pulse rounded bg-gray-200 motion-reduce:animate-none ${className}`} />
);

/**
 * Same geometry as `RescheduleListItem` (60px pill rows on desktop, cards below 768px), so the
 * list swaps in without moving anything below it.
 */
export const RescheduleListSkeleton: React.FC = () => (
  <div role="status" aria-busy="true" className="flex w-full flex-col gap-4">
    <span className="sr-only">Planungsbedarf wird geladen</span>
    {Array.from({ length: ROWS }).map((_, i) => (
      <React.Fragment key={i}>
        <div className="rounded-2xl bg-white px-4 py-3 md:hidden" aria-hidden>
          <div className="flex items-center justify-between">
            <Bar className="h-4 w-16 !rounded-full" />
            <Bar className="h-3 w-20" />
          </div>
          <Bar className={`mt-3 h-4 ${TITLE_WIDTHS[i % TITLE_WIDTHS.length]}`} />
          <Bar className="mt-2 h-3 w-1/3" />
          <Bar className="mt-3 h-3 w-1/2" />
        </div>

        <div
          className="hidden min-h-[60px] items-center rounded-[30px] bg-white px-[15px] md:grid"
          style={{ gridTemplateColumns: rescheduleColumns, columnGap: 12 }}
          aria-hidden
        >
          <Bar className="h-5 w-16 !rounded-full" />
          <Bar className={`h-3.5 ${TITLE_WIDTHS[i % TITLE_WIDTHS.length]}`} />
          <Bar className="h-3.5 w-2/3" />
          <Bar className="h-3.5 w-20" />
          <div className="flex flex-col gap-1.5">
            <Bar className="h-3 w-16" />
            <Bar className="h-3.5 w-3/4" />
          </div>
        </div>
      </React.Fragment>
    ))}
  </div>
);
